import React, { Component } from 'react'
import { database } from '../../firebase'
import { ref, child, query, orderByChild, equalTo, get, onChildAdded, onChildRemoved, off } from 'firebase/database'
import { withRouter } from '../../withRouter'
import Title from '../components/Title'
import RowView from '../modules/RowViewMode'
import './View.css'

class View extends Component {
  constructor (props) {
    super(props)
    this.state = {
      rows: [],
      options: []
    }
    this.rows = []
    this.dbRefQ = ref(database, 'quinielas')
    this.dbRefG = ref(database, 'grupos')
  }
  componentDidMount () {
    const groupsQuery = query(child(this.dbRefG, 'index'), orderByChild('mode'), equalTo(this.props.match.params.mode))
    get(groupsQuery)
      .then((snap) => {
        const groups = []
        snap.forEach((child) => {
          groups.push({
            value: child.key,
            label: child.val().titulo
          })
        })
        this.setState({
          options: groups
        })
      })
      .catch((err) => {
        console.error(err)
      })
    
    const indexRef = child(this.dbRefQ, 'index/' + this.props.match.params.mode)
    onChildAdded(indexRef, (snap) => {
      this.rows.push({
        id: snap.key,
        fecha: snap.val().fecha,
        actual: snap.val().current,
        activa: snap.val().active,
        desde: snap.val().desde
      })
      this.rows.sort((a, b) => {
        if (a.desde < b.desde) {
          return 1
        }
        if (a.desde > b.desde) {
          return -1
        }
        return 0
      })
      this.setState({
        rows: this.rows
      })
    })
    onChildRemoved(indexRef, (snap) => {
      this.rows = this.rows.filter((row) => row.id !== snap.key)
      this.setState({
        rows: this.rows
      })
    })
  }
  componentWillUnmount () {
    const indexRef = child(this.dbRefQ, 'index/' + this.props.match.params.mode)
    off(indexRef)
  }
  render () {
    return (
      <div className='view'>
        <Title title='Consultar quiniela' />
        <div className='view__content'>
          <div className='view__content__header'>
            <h3>Consulta los resultados de una quiniela</h3>
          </div>
          <div className='view__content__body'>
            {this.state.rows.map((row) => (
              <RowView
                {...row}
                key={row.id}
                history={this.props.history}
                options={this.state.options}
              />))}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(View)
